import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="grid-bulk-actions"
// Manages select-all / individual checkboxes for datagrid rows,
// populates hidden id inputs into the shared bulk-action form,
// and shows/hides the bulk-actions dropdown depending on selection.
export default class extends Controller {
  static targets = ["idsContainer", "actionsDropdown", "counter", "headerCheckbox", "checkbox", "actionForm"]

  declare idsContainerTarget:       HTMLElement
  declare actionsDropdownTarget:    HTMLElement
  declare counterTargets:           HTMLElement[]
  declare headerCheckboxTarget:     HTMLInputElement
  declare checkboxTargets:          HTMLInputElement[]
  declare actionFormTarget:         HTMLFormElement
  declare hasHeaderCheckboxTarget:  boolean
  declare hasActionsDropdownTarget: boolean
  declare hasIdsContainerTarget:    boolean
  declare hasActionFormTarget:      boolean

  connect() {
    this.refresh()
  }

  // Called when any individual checkbox changes
  toggle() {
    if (this.hasHeaderCheckboxTarget) {
      const all = this.checkboxTargets.length
      const checked = this.checkboxTargets.filter(c => c.checked).length
      this.headerCheckboxTarget.checked = all > 0 && all === checked
      this.headerCheckboxTarget.indeterminate = checked > 0 && checked < all
    }
    this.refresh()
  }

  // Called when the "select all" header checkbox changes
  toggleAll() {
    if (!this.hasHeaderCheckboxTarget) return
    const checked = this.headerCheckboxTarget.checked
    this.checkboxTargets.forEach(c => (c.checked = checked))
    this.refresh()
  }

  // Rebuild hidden inputs and toggle visibility of the dropdown
  refresh() {
    if (!this.hasIdsContainerTarget) return

    this.idsContainerTarget.innerHTML = ""

    const selectedIds = this.checkboxTargets
      .filter(c => c.checked)
      .map(c => c.value)

    selectedIds.forEach(id => {
      const input    = document.createElement("input")
      input.type = "hidden"
      input.name = "grid[ids][]"
      input.value = id
      this.idsContainerTarget.appendChild(input)
    })

    if (this.hasActionsDropdownTarget) {
      if (selectedIds.length > 0) {
        this.actionsDropdownTarget.classList.remove("d-none")
      } else {
        this.actionsDropdownTarget.classList.add("d-none")
      }
    }

    this.counterTargets.forEach(el => {
      el.textContent = selectedIds.length > 0 ? `(${selectedIds.length})` : ""
    })
  }

  // Called by each action button via data-action="click->grid-bulk-actions#submitAction"
  submitAction(event: Event) {
    event.preventDefault()
    const btn = event.currentTarget as HTMLElement
    const method = btn.getAttribute("data-method") || "post"
    const url = btn.getAttribute("data-url")    || ""

    if (!this.hasActionFormTarget) return
    const form = this.actionFormTarget
    form.action = url

    let methodInput = form.querySelector<HTMLInputElement>("input[name='_method']")
    if (!methodInput) {
      methodInput = document.createElement("input")
      methodInput.type = "hidden"
      methodInput.name = "_method"
      form.appendChild(methodInput)
    }

    if (method.toLowerCase() === "delete") {
      methodInput.value = "delete"
      form.method = "post"
    } else {
      methodInput.value = method
      form.method = method
    }

    form.submit()
  }
}


